import {client} from "./client";

const paths = {
  company: {
    statistic: '/company/statistic',
  },
  share: {
    summary: '/share/summary',
  },
  auth: {
    login: '/auth/login',
  }
}

export default {
  company: {
    statistic() {
      return client.get(paths.company.statistic)
    },
  },
  share: {
    summary() {
      return client.get(paths.share.summary)
    },
  },
  auth: {
    login(username, password) {
      return client.post(paths.auth.login, {
        username,
        password,
      })
    }
  }
}
